import React from 'react';
import {
  useGetMediaByFaxId,
} from 'pages/Dashboard/pages/Fax/hooks';
import usePreviewMediaClick from 'pages/Dashboard/hooks/usePreviewMediaClick';
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import ToolTip from 'core/components/Tooltip';
import isNil from 'lodash/isNil';
import head from 'lodash/head';
import clsx from 'clsx';
import Button from 'pages/Dashboard/components/Button';

type Props = {
  faxId: number;
};

export default function FaxMultiMediaLink({
  faxId,
}: Props) {
  const { data } = useGetMediaByFaxId(faxId, true);
  const handleMultiMediaClick = usePreviewMediaClick();
  const media = head(data?.list);
  const hasMedia = !isNil(media);

  return (
    <ToolTip title={hasMedia ? 'View Attachment' : 'No Fax Attachment'}>
      <div className={clsx({ 'cursor-not-allowed': !hasMedia })}>
        <Button
          onClick={() => {
            if (hasMedia) {
              handleMultiMediaClick(media);
            }
          }}
          disabled={!hasMedia}
          color={hasMedia ? 'primary' : undefined}
          className="flex items-center gap-1 !py-1 !px-2"
          variant="outlined"
        >
          <AttachFileRoundedIcon className="!w-4 !h-4 !text-inherit" />
          <span className="!text-xs !text-gray-700 !font-medium">View Fax Attachment</span>
        </Button>
      </div>
    </ToolTip>
  );
}
